document.addEventListener('DOMContentLoaded', () => {
  const headerInner = document.querySelector('.site-header__inner')
  const header = document.querySelector('.site-header')
  const menuToggle = document.querySelector('.menu-toggle')
  const primaryNav = document.querySelector('.primary-nav')
  const menuClose = document.querySelector('.menu-close')
  const isMobileMenu = () => window.matchMedia('(max-width: 1024px)').matches

  const setHeaderHeight = () => {
    if (!header) return
    const height = header.getBoundingClientRect().height
    document.documentElement.style.setProperty('--site-header-height', `${height}px`)
  }

  setHeaderHeight()
  window.addEventListener('load', setHeaderHeight)
  window.addEventListener('resize', setHeaderHeight)
  header?.querySelectorAll('.announcement-bar img').forEach((img) => {
    if (img.complete) return
    img.addEventListener('load', setHeaderHeight, { once: true })
  })

  document.addEventListener('shopify:section:load', setHeaderHeight)
  document.addEventListener('shopify:section:unload', setHeaderHeight)

  const setBodyScrollLock = (lock) => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    const shouldPad = !isMobileMenu() && scrollbarWidth > 0
    if (lock && shouldPad) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    } else {
      document.body.style.paddingRight = ''
    }
  }

  const closeMenu = () => {
    headerInner?.classList.remove('is-open')
    document.body.classList.remove('menu-open')
    setBodyScrollLock(false)
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false')
  }

  if (menuToggle && headerInner) {
    menuToggle.setAttribute('aria-expanded', 'false')
    menuToggle.addEventListener('click', () => {
      const willOpen = !headerInner.classList.contains('is-open')
      headerInner.classList.toggle('is-open')
      document.body.classList.toggle('menu-open', willOpen)
      setBodyScrollLock(willOpen)
      menuToggle.setAttribute('aria-expanded', String(willOpen))
    })
  }

  if (menuClose) {
    menuClose.addEventListener('click', () => {
      closeMenu()
    })
  }

  if (primaryNav) {
    primaryNav.addEventListener('click', (event) => {
      if (!isMobileMenu()) return
      const target = event.target
      if (target instanceof Element && target.closest('a')) {
        closeMenu()
      }
    })
    primaryNav.addEventListener('click', (event) => {
      if (!isMobileMenu()) return
      if (event.target === primaryNav) closeMenu()
    })
  }

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu()
  })

  window.addEventListener('resize', () => {
    if (!isMobileMenu()) closeMenu()
  })

  // =====================================================
  // Title-case product titles (Spanish-aware lowercase + first-of-each-word uppercase)
  // Handles all-caps source data without requiring merchant edits.
  // =====================================================
  const SPANISH_LOWER_WORDS = new Set(['de','del','la','las','el','los','y','o','u','en','con','a','al','por','para','sin','sobre','un','una','unos','unas'])
  function toTitleCaseSpanish(str) {
    if (!str) return str
    const lower = str.toLowerCase()
    return lower.replace(/([a-záéíóúñü]+)/gi, (word, _, offset) => {
      if (offset > 0 && SPANISH_LOWER_WORDS.has(word)) return word
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
  }
  function titleCaseProductTitles(root) {
    (root || document).querySelectorAll('.collection-grid__title, .collection-grid__vendor').forEach((el) => {
      const raw = el.textContent.trim()
      if (!raw) return
      el.textContent = toTitleCaseSpanish(raw)
    })
  }
  titleCaseProductTitles(document)

  const filterButton = document.querySelector('[data-action="toggle-filters"]')
  const sidebar = document.querySelector('[data-filters]')
  if (filterButton && sidebar) {
    filterButton.addEventListener('click', () => {
      const isHidden = sidebar.hasAttribute('hidden')
      if (isHidden) sidebar.removeAttribute('hidden')
      else sidebar.setAttribute('hidden', '')
    })
  }

  // Close filter dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    const openDropdowns = document.querySelectorAll('details[data-filter-dropdown][open]')
    openDropdowns.forEach((d) => { if (!d.contains(e.target)) d.open = false })
  })
  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    document.querySelectorAll('details[data-filter-dropdown][open]').forEach((d) => { d.open = false })
  })

  const viewButtons = document.querySelectorAll('.view-toggle [data-view]')
  if (viewButtons.length) {
    viewButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        viewButtons.forEach((b) => b.classList.remove('is-active'))
        btn.classList.add('is-active')
        const view = btn.getAttribute('data-view')
        const currentGrid = document.querySelector('[data-collection-grid]')
        if (currentGrid) currentGrid.classList.toggle('is-list', view === 'list')
      })
    })
  }

  document.querySelectorAll('.dropdown__toggle').forEach((btn) => {
    const parent = btn.parentElement
    const panel = parent ? parent.querySelector('.dropdown__panel') : null
    if (!panel) return
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true'
      btn.setAttribute('aria-expanded', String(!expanded))
      parent?.classList.toggle('is-open', !expanded)
      if (!isMobileMenu()) {
        panel.style.opacity = expanded ? 0 : 1
        panel.style.transform = expanded ? 'translateY(6px)' : 'translateY(0)'
        panel.style.pointerEvents = expanded ? 'none' : 'all'
      }
    })
  })

  const hero = document.querySelector('[data-hero-campaign]')
  if (hero) {
    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'))
    const dotsWrap = hero.querySelector('[data-hero-dots]')
    const prev = hero.querySelector('[data-hero-prev]')
    const next = hero.querySelector('[data-hero-next]')
    const autoplay = hero.getAttribute('data-autoplay') === 'true'
    const interval = parseInt(hero.getAttribute('data-interval') || '6000', 10)
    let current = 0
    let timer = null

    const activate = (index) => {
      current = (index + slides.length) % slides.length
      slides.forEach((slide, idx) => {
        const isActive = idx === current
        slide.classList.toggle('is-active', isActive)

        // Reiniciar animaciones de keywords cuando el slide se activa
        if (isActive) {
          const keywords = slide.querySelectorAll('.campaign-hero__keyword')
          keywords.forEach((keyword) => {
            // Forzar reflow para reiniciar la animación
            keyword.style.animation = 'none'
            keyword.offsetHeight // Trigger reflow
            keyword.style.animation = null
          })
        }
      })
      if (dotsWrap) {
        dotsWrap.querySelectorAll('button').forEach((btn, idx) => {
          btn.classList.toggle('is-active', idx === current)
        })
      }
    }

    if (dotsWrap) {
      slides.forEach((_, idx) => {
        const dot = document.createElement('button')
        dot.type = 'button'
        dot.addEventListener('click', () => {
          activate(idx)
          restart()
        })
        dotsWrap.appendChild(dot)
      })
    }

    const nextSlide = (delta) => {
      activate(current + delta)
    }

    prev?.addEventListener('click', () => {
      nextSlide(-1)
      restart()
    })

    next?.addEventListener('click', () => {
      nextSlide(1)
      restart()
    })

    const start = () => {
      if (!autoplay || slides.length <= 1) return
      timer = window.setInterval(() => nextSlide(1), Math.max(interval, 3000))
    }

    const stop = () => {
      if (timer) {
        window.clearInterval(timer)
        timer = null
      }
    }

    const restart = () => {
      stop()
      start()
    }

    hero.addEventListener('mouseenter', stop)
    hero.addEventListener('mouseleave', start)

    activate(0)
    start()
  }

  document.querySelectorAll('[data-offers]').forEach((module) => {
    const track = module.querySelector('.offers-carousel__track')
    const prev = module.querySelector('[data-offers-prev]')
    const next = module.querySelector('[data-offers-next]')
    if (!track) return

    const step = 260
    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -step, behavior: 'smooth' })
    })
    next?.addEventListener('click', () => {
      track.scrollBy({ left: step, behavior: 'smooth' })
    })
  })

  // Quantity selector buttons
  document.querySelectorAll('[data-quantity-minus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input')
      if (input) {
        const currentValue = parseInt(input.value) || 1
        if (currentValue > 1) {
          input.value = currentValue - 1
        }
      }
    })
  })

  document.querySelectorAll('[data-quantity-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input')
      if (input) {
        const currentValue = parseInt(input.value) || 1
        const max = parseInt(input.max) || 0
        if (max > 0 && currentValue >= max) return
        input.value = currentValue + 1
      }
    })
  })

  // =====================================================
  // PRODUCT VARIANTS AND GALLERY
  // =====================================================
  const productSection = document.querySelector('[data-product-section]')
  if (productSection) {
    const sectionId = productSection.getAttribute('data-section-id')
    const productJsonEl = document.getElementById(`ProductJSON-${sectionId}`)

    if (productJsonEl) {
      const product = JSON.parse(productJsonEl.textContent)

      // Filter B2B variants for non-logged-in users
      const b2bEl = document.getElementById(`B2BVariants-${sectionId}`)
      if (b2bEl) {
        const b2bIds = JSON.parse(b2bEl.textContent)
        if (b2bIds.length) {
          product.variants = product.variants.filter(v => !b2bIds.includes(v.id))
        }
      }

      // Shared inventory data (stock compartido entre variantes)
      const sharedInvEl = document.getElementById(`SharedInventory-${sectionId}`)
      const sharedInventory = sharedInvEl ? JSON.parse(sharedInvEl.textContent) : null

      // DOM Elements
      const variantSelects = productSection.querySelectorAll('[data-variant-option]')
      const variantIdInput = productSection.querySelector('[data-variant-id-input]')
      const currentPriceEl = productSection.querySelector('[data-current-price]')
      const comparePriceEl = productSection.querySelector('[data-compare-price]')
      const promoBadgeEl = productSection.querySelector('[data-promo-badge]')
      const stockEl = productSection.querySelector('[data-product-stock]')
      const addToCartBtn = productSection.querySelector('[data-add-to-cart-btn]')
      const galleryMain = productSection.querySelector('[data-product-gallery-main]')
      const thumbs = productSection.querySelectorAll('.product-gallery__thumb')
      const quantityInput = productSection.querySelector('.quantity-input')
      const sharedStockMsg = productSection.querySelector('[data-shared-stock-msg]')

      // Currency formatting helper (uses Shopify money format)
      const formatMoney = (cents) => {
        const amount = (cents / 100).toFixed(2)
        return `$${amount} MXN`
      }

      // Find variant by selected options
      const getSelectedVariant = () => {
        const selectedOptions = []
        variantSelects.forEach((select) => {
          selectedOptions.push(select.value)
        })

        return product.variants.find((variant) => {
          return variant.options.every((option, index) => {
            return option === selectedOptions[index]
          })
        })
      }

      // Update URL with variant parameter
      const updateURL = (variantId) => {
        const url = new URL(window.location.href)
        url.searchParams.set('variant', variantId)
        window.history.replaceState({}, '', url.toString())
      }

      // Update price display
      const updatePrice = (variant) => {
        if (!currentPriceEl) return

        currentPriceEl.textContent = formatMoney(variant.price)

        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price)
            comparePriceEl.style.display = ''
          } else {
            comparePriceEl.style.display = 'none'
          }
        }
        if (promoBadgeEl) {
          promoBadgeEl.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price)
        }
      }

      // Update stock status
      const updateStock = (variant) => {
        if (!stockEl) return

        if (variant.available) {
          stockEl.innerHTML = '<span class="stock-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg></span>En stock'
        } else {
          stockEl.innerHTML = 'Producto temporalmente agotado'
        }
      }

      // Update add to cart button
      const updateAddToCartButton = (variant) => {
        if (!addToCartBtn) return

        if (variant.available) {
          addToCartBtn.disabled = false
          addToCartBtn.style.opacity = '1'
          addToCartBtn.style.cursor = 'pointer'
        } else {
          addToCartBtn.disabled = true
          addToCartBtn.style.opacity = '0.5'
          addToCartBtn.style.cursor = 'not-allowed'
        }
      }

      // Update main gallery image
      const updateGalleryImage = (imageSrc, imageAlt) => {
        if (!galleryMain) return

        const mainImg = galleryMain.querySelector('img')
        if (mainImg) {
          mainImg.src = imageSrc
          mainImg.alt = imageAlt || product.title
        }
      }

      // Update active thumbnail
      const setActiveThumb = (activeThumb) => {
        thumbs.forEach((thumb) => thumb.classList.remove('is-active'))
        if (activeThumb) {
          activeThumb.classList.add('is-active')
        }
      }

      // Find thumb by image ID
      const findThumbByImageId = (imageId) => {
        return Array.from(thumbs).find((thumb) => {
          return thumb.getAttribute('data-image-id') == imageId
        })
      }

      // Shared stock: calcular máximo disponible para una variante
      const getMaxQuantity = (variantId) => {
        if (!sharedInventory) return 0
        const factor = sharedInventory.factors[variantId] || 1
        return Math.floor(sharedInventory.baseStock / factor)
      }

      // Shared stock: actualizar indicador y límite de cantidad
      const updateSharedStockLimit = (variant) => {
        if (!sharedInventory || !quantityInput) return

        const factor = sharedInventory.factors[variant.id] || 1
        const maxQty = Math.floor(sharedInventory.baseStock / factor)

        quantityInput.max = maxQty
        if (parseInt(quantityInput.value) > maxQty) {
          quantityInput.value = Math.max(maxQty, 1)
        }

        if (sharedStockMsg) {
          if (maxQty > 0) {
            const unitLabel = factor > 1 ? variant.title || variant.options.join(' ') : 'unidades'
            sharedStockMsg.textContent = `Disponible: ${maxQty}`
            sharedStockMsg.style.display = ''
            sharedStockMsg.classList.remove('is-error')
          } else {
            sharedStockMsg.textContent = 'Sin stock disponible'
            sharedStockMsg.style.display = ''
            sharedStockMsg.classList.add('is-error')
          }
        }
      }

      // Main variant change handler
      const onVariantChange = () => {
        const variant = getSelectedVariant()

        if (!variant) {
          // No matching variant found - disable purchase
          if (addToCartBtn) {
            addToCartBtn.disabled = true
            addToCartBtn.style.opacity = '0.5'
          }
          return
        }

        // Update hidden input
        if (variantIdInput) {
          variantIdInput.value = variant.id
        }

        // Update URL
        updateURL(variant.id)

        // Update price
        updatePrice(variant)

        // Update stock
        updateStock(variant)

        // Update button
        updateAddToCartButton(variant)

        // Update shared stock limit
        updateSharedStockLimit(variant)

        // Update gallery if variant has specific image
        if (variant.featured_image) {
          const variantImageSrc = variant.featured_image.src.replace(/(\.[^.]+)$/, '_800x$1')
          updateGalleryImage(variantImageSrc, variant.featured_image.alt)

          // Find and activate corresponding thumbnail
          const correspondingThumb = findThumbByImageId(variant.featured_image.id)
          if (correspondingThumb) {
            setActiveThumb(correspondingThumb)
          }
        }
      }

      // Thumbnail click handler
      const onThumbClick = (thumb) => {
        const fullSrc = thumb.getAttribute('data-full-src')
        const alt = thumb.getAttribute('alt')

        updateGalleryImage(fullSrc, alt)
        setActiveThumb(thumb)
      }

      // Initialize variant selects
      variantSelects.forEach((select) => {
        select.addEventListener('change', onVariantChange)
      })

      // Initialize thumbnail clicks
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => onThumbClick(thumb))
      })

      // Handle initial variant from URL
      const urlParams = new URLSearchParams(window.location.search)
      const urlVariantId = urlParams.get('variant')
      if (urlVariantId) {
        const urlVariant = product.variants.find(v => v.id == urlVariantId)
        if (urlVariant) {
          // Set select values to match URL variant
          urlVariant.options.forEach((optionValue, index) => {
            const select = variantSelects[index]
            if (select) {
              select.value = optionValue
            }
          })
          // Trigger update to sync everything
          onVariantChange()
        }
      }

      // Shared stock: validate on form submit (check cart for same product)
      if (sharedInventory) {
        const form = productSection.querySelector('.product-info__form')
        if (form) {
          form.addEventListener('submit', async (e) => {
            const variant = getSelectedVariant()
            if (!variant) return

            const factor = sharedInventory.factors[variant.id] || 1
            const qty = parseInt(quantityInput?.value) || 1
            const unitsNeeded = qty * factor

            // Check if adding this would exceed base stock
            e.preventDefault()
            addToCartBtn.disabled = true

            try {
              const cartRes = await fetch('/cart.js')
              const cart = await cartRes.json()

              // Sum base units already in cart for this product
              let unitsInCart = 0
              for (const item of cart.items) {
                if (item.product_id === product.id) {
                  const itemFactor = sharedInventory.factors[item.variant_id] || 1
                  unitsInCart += item.quantity * itemFactor
                }
              }

              if (unitsInCart + unitsNeeded > sharedInventory.baseStock) {
                const remaining = sharedInventory.baseStock - unitsInCart
                const maxCanAdd = Math.floor(remaining / factor)
                if (sharedStockMsg) {
                  sharedStockMsg.textContent = maxCanAdd > 0
                    ? `Stock insuficiente. Puedes agregar hasta ${maxCanAdd} unidades más.`
                    : 'Stock insuficiente. Ya tienes el máximo en tu carrito.'
                  sharedStockMsg.style.display = ''
                  sharedStockMsg.classList.add('is-error')
                }
                addToCartBtn.disabled = false
                return
              }

              // Validation passed - submit normally
              form.submit()
            } catch (err) {
              // On error, allow normal submit
              form.submit()
            }
          })
        }

        // Enforce max on manual quantity input
        if (quantityInput) {
          quantityInput.addEventListener('change', () => {
            const max = parseInt(quantityInput.max) || 0
            const val = parseInt(quantityInput.value) || 1
            if (max > 0 && val > max) {
              quantityInput.value = max
            }
            if (val < 1) {
              quantityInput.value = 1
            }
          })
        }
      }
    }
  }

  // Add to cart buttons in best sellers
  document.querySelectorAll('.product-card__add-to-cart').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      const variantId = btn.getAttribute('data-product-id')
      if (!variantId || btn.disabled) return

      // Add loading state
      btn.disabled = true
      btn.style.opacity = '0.6'

      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(() => {
        // Show success feedback
        btn.style.backgroundColor = '#6cb33f'
        setTimeout(() => {
          btn.style.backgroundColor = ''
          btn.disabled = false
          btn.style.opacity = '1'
        }, 1000)

        // Update cart count if badge exists
        const cartBadge = document.querySelector('.cart-count-badge')
        if (cartBadge) {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              cartBadge.textContent = cart.item_count
              if (cart.item_count > 0) cartBadge.removeAttribute('hidden')
              else cartBadge.setAttribute('hidden', '')
            })
        }
      })
      .catch(error => {
        console.error('Error:', error)
        btn.disabled = false
        btn.style.opacity = '1'
      })
    })
  })

  // =====================================================
  // COLLECTION GRID — AJAX ADD TO CART
  // =====================================================
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.collection-grid__add-form')
    if (!form) return
    e.preventDefault()

    const btn = form.querySelector('button[type="submit"]')
    const originalText = btn.textContent
    btn.disabled = true
    btn.textContent = 'Agregando...'
    btn.style.opacity = '0.6'

    const formData = new FormData(form)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(formData.get('id')),
        quantity: Number(formData.get('quantity')) || 1
      })
    })
    .then(function(res) { return res.json() })
    .then(function() {
      btn.textContent = 'Agregado ✓'
      btn.style.backgroundColor = '#6cb33f'
      setTimeout(function() {
        btn.textContent = originalText
        btn.style.backgroundColor = ''
        btn.disabled = false
        btn.style.opacity = '1'
      }, 1500)

      var cartBadge = document.querySelector('.cart-count-badge')
      if (cartBadge) {
        fetch('/cart.js')
          .then(function(r) { return r.json() })
          .then(function(cart) {
            cartBadge.textContent = cart.item_count
            if (cart.item_count > 0) cartBadge.removeAttribute('hidden')
            else cartBadge.setAttribute('hidden', '')
          })
      }
    })
    .catch(function(err) {
      console.error('Add to cart error:', err)
      btn.textContent = originalText
      btn.disabled = false
      btn.style.opacity = '1'
    })
  })

  // =====================================================
  // COLLECTION AJAX FILTERING
  // =====================================================
  const filterForm = document.querySelector('[data-collection-filters]')
  const collectionMain = document.querySelector('[data-collection-main]')
  if (filterForm && collectionMain) {
    const buildFilterURL = () => {
      const formData = new FormData(filterForm)
      const params = new URLSearchParams()
      for (const [key, value] of formData.entries()) {
        if (value !== '') params.append(key, value)
      }
      const sortSelect = document.querySelector('[data-collection-sort]')
      if (sortSelect && sortSelect.value) {
        params.set('sort_by', sortSelect.value)
      }
      return window.location.pathname + (params.toString() ? '?' + params.toString() : '')
    }

    const fetchAndUpdate = async (url) => {
      collectionMain.style.opacity = '0.5'
      // Preserve which filter dropdowns were open before swap (form sits outside collectionMain)
      const openDropdownNames = Array.from(
        filterForm.querySelectorAll('details[data-filter-dropdown][open]')
      ).map(d => d.getAttribute('data-filter-name'))
      try {
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        const html = await res.text()
        const doc = new DOMParser().parseFromString(html, 'text/html')
        const newMain = doc.querySelector('[data-collection-main]')
        if (newMain) collectionMain.innerHTML = newMain.innerHTML
        // Re-apply list view if it was active before AJAX update
        const listBtn = document.querySelector('.view-toggle [data-view="list"].is-active')
        if (listBtn) {
          const updatedGrid = collectionMain.querySelector('[data-collection-grid]')
          if (updatedGrid) updatedGrid.classList.add('is-list')
        }
        titleCaseProductTitles(collectionMain)
        const newFilters = doc.querySelector('[data-collection-filters]')
        if (newFilters) filterForm.innerHTML = newFilters.innerHTML
        // Restore previously-open filter dropdowns so multi-select doesn't keep closing
        openDropdownNames.forEach(name => {
          if (!name) return
          const d = filterForm.querySelector(`details[data-filter-dropdown][data-filter-name="${name}"]`)
          if (d) d.open = true
        })
        history.pushState({}, '', url)
      } catch (e) {
        window.location = url
      }
      collectionMain.style.opacity = '1'
    }

    filterForm.addEventListener('change', (e) => {
      if (e.target.type === 'number') return
      fetchAndUpdate(buildFilterURL())
    })

    filterForm.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.type === 'number') {
        e.preventDefault()
        fetchAndUpdate(buildFilterURL())
      }
    })

    filterForm.addEventListener('focusout', (e) => {
      if (e.target.type === 'number' && e.target.name.startsWith('filter.v.price')) {
        fetchAndUpdate(buildFilterURL())
      }
    })

    window.addEventListener('popstate', () => fetchAndUpdate(window.location.href))

    collectionMain.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]')
      if (link && (link.classList.contains('chip--active') || link.closest('.collection-grid__pagination'))) {
        e.preventDefault()
        fetchAndUpdate(link.href)
      }
    })
  }

  // Ordenar colección: el <select> está dentro del contenedor que el AJAX
  // reemplaza, así que delegamos en un padre estable y navegamos directo
  // (el orden lo aplica Shopify en el servidor — "Características" = orden manual).
  const collMainForSort = document.querySelector('[data-collection-main]')
  if (collMainForSort) {
    collMainForSort.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-collection-sort]')
      if (!sel) return
      const u = new URL(window.location.href)
      u.searchParams.set('sort_by', sel.value)
      window.location.href = u.toString()
    })
  }

  const heroBannerCleanups = new WeakMap()

  const initHeroBanner = (root) => {
    if (!root || root.dataset.heroReady === 'true') return
    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'))
    if (!slides.length) return
    root.dataset.heroReady = 'true'

    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'))
    const prev = root.querySelector('[data-hero-prev]')
    const next = root.querySelector('[data-hero-next]')
    const pauseBtn = root.querySelector('[data-hero-pause]')
    const status = root.querySelector('[data-hero-status]')
    const autoplay = root.getAttribute('data-autoplay') === 'true'
    const interval = parseInt(root.getAttribute('data-interval') || '6000', 10)
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    let current = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0)
    let timer = null
    let hovering = false
    let focusInside = false
    let userPaused = false

    const syncVideos = () => {
      slides.forEach((slide, idx) => {
        const video = slide.querySelector('video')
        if (!video) return
        video.muted = true
        video.defaultMuted = true
        if (idx === current) {
          const playPromise = video.play()
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {})
        } else {
          video.pause()
        }
      })
    }

    const activate = (index, announce) => {
      current = (index + slides.length) % slides.length
      slides.forEach((slide, idx) => {
        const isActive = idx === current
        slide.classList.toggle('is-active', isActive)
        if (isActive) slide.removeAttribute('aria-hidden')
        else slide.setAttribute('aria-hidden', 'true')
      })
      dots.forEach((dot, idx) => {
        const isActive = idx === current
        dot.classList.toggle('is-active', isActive)
        if (isActive) dot.setAttribute('aria-current', 'true')
        else dot.removeAttribute('aria-current')
      })
      syncVideos()
      if (announce && status) status.textContent = `Diapositiva ${current + 1} de ${slides.length}`
    }

    const stop = () => {
      if (timer) {
        window.clearInterval(timer)
        timer = null
      }
    }

    const start = () => {
      if (userPaused || hovering || focusInside || reducedMotion || !autoplay || slides.length <= 1) return
      stop()
      timer = window.setInterval(() => activate(current + 1, false), Math.max(interval, 3000))
    }

    const setUserPaused = (value) => {
      userPaused = value
      if (!pauseBtn) return
      pauseBtn.classList.toggle('is-paused', value)
      pauseBtn.setAttribute('aria-pressed', String(value))
      pauseBtn.setAttribute('aria-label', value ? 'Reanudar carrusel' : 'Pausar carrusel')
    }

    prev?.addEventListener('click', () => {
      activate(current - 1, true)
      start()
    })
    next?.addEventListener('click', () => {
      activate(current + 1, true)
      start()
    })
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        activate(idx, true)
        start()
      })
    })
    pauseBtn?.addEventListener('click', () => {
      setUserPaused(!userPaused)
      if (userPaused) stop()
      else start()
    })

    root.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey || slides.length <= 1) return
      if (event.key === 'ArrowLeft') {
        event.preventDefault()
        activate(current - 1, true)
        start()
      } else if (event.key === 'ArrowRight') {
        event.preventDefault()
        activate(current + 1, true)
        start()
      }
    })

    root.addEventListener('mouseenter', () => {
      hovering = true
      stop()
    })
    root.addEventListener('mouseleave', () => {
      hovering = false
      start()
    })
    root.addEventListener('focusin', () => {
      focusInside = true
      stop()
    })
    root.addEventListener('focusout', (event) => {
      if (root.contains(event.relatedTarget)) return
      focusInside = false
      start()
    })

    const onBlockSelect = (event) => {
      const slide = event.target.closest('[data-hero-slide]')
      if (!slide || !root.contains(slide)) return
      const index = slides.indexOf(slide)
      if (index === -1) return
      activate(index, false)
      stop()
    }

    document.addEventListener('shopify:block:select', onBlockSelect)

    const cleanup = () => {
      stop()
      document.removeEventListener('shopify:block:select', onBlockSelect)
      root.dataset.heroReady = 'false'
    }
    heroBannerCleanups.set(root, cleanup)
    syncVideos()
    start()
  }

  const bootHeroBanners = (scope) => {
    if (!scope || !scope.querySelectorAll) return
    scope.querySelectorAll('[data-hero-banner]').forEach(initHeroBanner)
  }

  bootHeroBanners(document)
  document.addEventListener('shopify:section:load', (event) => {
    bootHeroBanners(event.target)
  })
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-hero-banner]').forEach((root) => {
      const cleanup = heroBannerCleanups.get(root)
      if (cleanup) cleanup()
    })
  })
})
